<!--<div class="card">-->
<!--  <div class="card-body">-->
<!--    <div class="row">-->
<!--      <div class="col-lg-4">-->
<!--        <ng-multiselect-dropdown required [settings]="dropdownSettings" [placeholder]="'Tipo'" id="tipo" [data]="filtrife"-->
<!--                                 [(ngModel)]="filtrifeSel" (ngModelChange)="filtrifechng()">-->
<!--        </ng-multiselect-dropdown>-->
<!--      </div>-->
<!--      <div class="col-lg-4" *ngIf="filtrifeSel[0].id == 'A'">-->
<!--        <ng-multiselect-dropdown [settings]="dropdownSettings" [placeholder]="'Tipo'" id="tipoa" [data]="Tipi"-->
<!--                                 [(ngModel)]="TipiSelezionati" (ngModelChange)="TipoCambiato()">-->
<!--        </ng-multiselect-dropdown>-->
<!--      </div>-->
<!--    </div>-->
<!--  </div>-->
<!--</div>-->
<app-fullcalendar [events]="events"
                  (onEditClick)="Open($event)"
                  (onAddClick)="ScadAddButton()"
                  (onDateChanged)="DateChanged($event)"
                  (onClick)="Open($event)"
                  [Modificabile]="env.Modules.Scadenzario"
></app-fullcalendar>
